<template>
  <div>
    <iframe
      v-if="templateUrl"
      :src="templateUrl"
      ref="productGuideIframe"
      width="100%"
    />
    <v-layout column align-center v-else>
      <v-progress-circular indeterminate size="40" color="primary" />
    </v-layout>
  </div>
</template>

<script>
import get from 'lodash/get';
import { mapGetters } from 'vuex';
import FirmPreferenceMixins from '../mixins/FirmPreferenceMixins';

const SORABAN_TEMPLATE = {
  admin:
    'https://docs.google.com/document/d/e/2PACX-1vSE5ico9sUXSyVWqlLuH6Ut0hlnEiRySt02FpL_6GHnO1CRap5TACiVNvae5UrIGk9TPgiu-SYZoB83/pub?embedded=true',
  full:
    'https://docs.google.com/document/d/e/2PACX-1vQzy-ZKyfBnO77zylUqyGq2l8MuHbIjjvyFDoxW5we6udUyX1uFK9GB2NBriUVfVuwlIZtdDdLC5lHj/pub?embedded=true',
  basic:
    'https://docs.google.com/document/d/e/2PACX-1vQ_SxcwmsbK62wTawfgiLIVR0o2qgDRn-xIsrXqglF02C6XVeByB3yC3hEIPhFWREHQ-E4bLcMjWxzG/pub?embedded=true',
  group:
    'https://docs.google.com/document/d/e/2PACX-1vQLRAVWhUe8sqkeVjKVlv9NRvwGjcwKuhEq5PUy75fivEJn1XifIuXUjktMAzcNWgVpgwS29rLlp3u2/pub?embedded=true',
};

const ACCESS_KEYS = {
  partner: 'admin',
  full: 'full',
  basic: 'basic',
  group: 'group',
};

export default {
  name: 'ProductGuide',
  data() {
    return {
      templateUrl:
        'https://docs.google.com/document/d/e/2PACX-1vSE5ico9sUXSyVWqlLuH6Ut0hlnEiRySt02FpL_6GHnO1CRap5TACiVNvae5UrIGk9TPgiu-SYZoB83/pub?embedded=true',
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'user',
      currentFirm: 'currentFirm',
    }),
  },
  mixins: [FirmPreferenceMixins],
  methods: {
    get,
    async loadTemplate() {
      this.templateUrl = null;
      const userAccessKey = ACCESS_KEYS[this.currentUser.firm_access];
      if (
        get(this.currentUser, 'preferences.product_guide_docs', false) &&
        this.currentUser.preferences.product_guide_docs[userAccessKey]
      ) {
        // User properties
        this.templateUrl = this.currentUser.preferences.product_guide_docs[
          userAccessKey
        ];
      } else if (
        this.firmProductGuideDocs &&
        this.currentFirm.preferences.product_guide_docs[userAccessKey]
      ) {
        // Firm preferences
        this.templateUrl = this.currentFirm.preferences.product_guide_docs[
          userAccessKey
        ];
      } else {
        this.templateUrl = SORABAN_TEMPLATE[userAccessKey];
      }
    },
  },
  created() {
    this.loadTemplate();
  },
};
</script>

<style scoped>
iframe {
  margin-top: 60px;
  width: 1097px;
  height: calc(100vh - 125px);
  border: none;
  padding: 0;
  background-color: white;
}
</style>
